export default __webpack_public_path__ + "static/cni-1-36b87bc23d48a5a0c1ae3c5bb35b0804.png";